import React, { useCallback, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import UIButton from 'Components/UIComponents/UIButton';
import UIModal from 'Components/UIComponents/UIModal';
import UITextInput from 'Components/UIComponents/UITextInput';
import { REACT_APP_GOOGLE_RECAPTCHA_SITEKEY } from 'Utils/constants';

interface ConfirmCodeModalProps {
  onClose: () => void;
  sendCode: (code: string) => void;
  isSending?: boolean;
  title: string;
  subtitle?: string;
  placeholder?: string;
  resendCode?: (captchaKey: string) => void;
  codeLength?: number;
}

const ConfirmCodeModal = ({
  sendCode,
  isSending,
  title,
  subtitle,
  placeholder = '0A2b3C4d5E',
  resendCode,
  onClose,
  codeLength,
}: ConfirmCodeModalProps) => {
  const [codeAccess, setCodeAccess] = useState<string>('');
  const [showRecaptcha, setShowRecaptcha] = useState<boolean>(false);

  const handleCodeAccessChange = useCallback(event => {
    setCodeAccess(event.target.value);
  }, []);

  const handleCodeAccessSend = useCallback(() => {
    sendCode(codeAccess);
  }, [codeAccess, sendCode]);

  const handleResendCode = useCallback(
    (captchaKey: string) => {
      return resendCode && resendCode(captchaKey);
    },
    [resendCode],
  );

  return (
    <UIModal
      onClose={() => onClose()}
      className="confirmCodeModal"
      hideCloseIcon
      shouldCloseOnOverlayClick={false}
    >
      <div className="confirmCodeModal__wrapper">
        <div className="confirmCodeModal__title">{title}</div>
        {subtitle && <div className="confirmCodeModal__subtitle">{subtitle}</div>}
        <div className="confirmCodeModal__field">
          <UITextInput
            type="password"
            autoComplete="off"
            onChange={handleCodeAccessChange}
            value={codeAccess}
            placeholder={placeholder}
          />
          {resendCode && (
            <UIButton
              handleClick={() => {
                setShowRecaptcha(true);
              }}
              title="Resend"
              priority="secondary"
              disabled={isSending}
              isLoading={isSending}
            />
          )}
        </div>
        {showRecaptcha && (
          <div className="recaptcha__container">
            <ReCAPTCHA
              sitekey={REACT_APP_GOOGLE_RECAPTCHA_SITEKEY}
              onChange={e => {
                handleResendCode(e);
              }}
            />
          </div>
        )}
        <div className="confirmCodeModal__submit">
          <UIButton
            handleClick={handleCodeAccessSend}
            title="Send"
            priority="primary"
            disabled={isSending || !!(codeLength && codeAccess.length !== codeLength)}
            isLoading={isSending}
          />
        </div>
      </div>
    </UIModal>
  );
};

export default ConfirmCodeModal;
